import styled from '@emotion/styled';

export const Styled = {
	Container: styled.div`
		position: fixed;
		z-index: 9999999;
		box-sizing: border-box;
		inset: 0px;
		width: 100vw;
		height: 100vh;
		font-size: large;
		padding: 2rem 2rem 4rem;
		line-height: 1.2;
		white-space: pre-wrap;
		overflow: auto;
		background-color: rgba(0, 0, 0, 0.8);
		color: white;

		> p {
			margin: 0;
		}
	`,
	CloseButtonContainer: styled.div`
		display: flex;
		flex-flow: column;
		align-items: center;
		position: absolute;
		right: 24px;
		top: 24px;
	`,
	CloseButton: styled.button`
		color: rgb(255, 255, 255);
		line-height: 1rem;
		font-size: 1.5rem;
		font-weight: bold;
		cursor: pointer;
		background-color: transparent;
		border: none;
		padding: 4px;
		margin-bottom: 4px;
	`,
};
